import { render, staticRenderFns } from "./Accession.vue?vue&type=template&id=a8a2fdd4&scoped=true&"
import script from "./Accession.vue?vue&type=script&lang=js&"
export * from "./Accession.vue?vue&type=script&lang=js&"
import style0 from "./Accession.vue?vue&type=style&index=0&id=a8a2fdd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a2fdd4",
  null
  
)

export default component.exports